/* FIXME: couldn't get around disabling this rule */
/* eslint-disable @typescript-eslint/ban-types */

/**
 * Same as calling `Object.keys()` but with proper inferral
 */
export function getObjectKeys<T extends object>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>;
}
